// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__SgcJd","left":"style_left__isxUH","name":"style_name__mQ6RC","right":"style_right__9V7oN","list":"style_list__cqg6U","nButton":"style_nButton__+GMtx"};